import isEqual from 'lodash/isEqual'
import mapValues from 'lodash/mapValues'
import merge from 'lodash/merge'
import pick from 'lodash/pick'
import remove from 'lodash/remove'
import trim from 'lodash/trim'
import unionWith from 'lodash/unionWith'
import uniq from 'lodash/uniq'
import { routerReducer } from 'react-router-redux'
import { combineReducers } from 'redux'

import * as actions from '../actions/Buy'
import { findomestic2compass } from '../components/buy/utils'
import * as types from '../constants/ActionTypes'
import { getServizioAssicurativoUid } from '../utils/findomesticUtils'
import {
  transformComuniCittadinanzaV2Result,
  transformComuniResidenzaV2Result,
  transformComuniV2Result,
  transformIdentityCardV2Result,
  transformLicenseV2Result,
  transformPassportV2Result,
} from '../utils/searchComuniUtils'
import { paddInPath } from '../utils/stringUtils'
import { stepsVisited } from './Common'
import { nlt } from './Noleggia'

export const ui = function ui(state = {}, action) {
  switch (action.type) {
    case actions.POST_TRANSAZIONI_ADD_CALLBACK:
      return { ...state, croStatus: true }
    case types.POST_BONIFICO_DISTINTA_FILE_UPLOAD:
      return { ...state, distintaUploadStatus: true }
    case actions.FETCHING:
      return { ...state, ...action.payload }
    case actions.PHASECHANGE:
      return { ...state, ...action.payload }
    case actions.PAYMENT_METHOD_SELECTED:
      if (
        'reset' in action.payload &&
        action.payload.reset &&
        state.last > 20
      ) {
        return { ...state, last: 20 }
      }
      return state
    case actions.BUYHELPER:
      return { ...state, buyHelper: !state.buyHelper }
    case actions.BUYHELP_DOCUMENTI:
      const newStatus =
        action.payload !== undefined
          ? !!action.payload
          : !state.buyHelperDocumenti
      return { ...state, buyHelperDocumenti: newStatus }
    case types.STORE_RESTORE_CALLBACK:
      return { ...state, ...action.payload.data.result.frontend.ui }
    case actions.SET_PAGE_SETTINGS:
      return {
        ...state,
        settings: pick(action.payload.data.result, [
          'pageType',
          'productType',
          'phoneNumber',
        ]),
      }
    case types.GET_ORDINI_CODICE_PREVENTIVO:
    case types.GET_NLT_CANONE_PERSONALIZZATO_V1:
      const sellout_settings_acquista =
        action.payload.data.result.sellout_settings &&
        action.payload.data.result.sellout_settings.acquista
          ? action.payload.data.result.sellout_settings.acquista
          : {}
      const sellout_settings_noleggia =
        action.payload.data.result.sellout_settings &&
        action.payload.data.result.sellout_settings.noleggia
          ? action.payload.data.result.sellout_settings.noleggia
          : {}

      const hasFinancementId = action.payload.data.result.id_finanziamento

      if (hasFinancementId) {
        sellout_settings_acquista.bonifico_settings = {
          mode: 'DISABLED',
        }

        sellout_settings_acquista.finanziamento_settings = {
          mode: 'ONLY_QUOTATION',
        }
      }

      return {
        ...state,
        sellout_settings_acquista,
        sellout_settings_noleggia,
      }
    default:
      return state
  }
}

export const product = function product(state = {}, action) {
  switch (action.type) {
    case actions.NEW_PRODUCT_DETAILS:
    case types.GET_CMS_AUTO_V4:
      const data = action.payload.data.result
      return { ...state, ...data }
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.product,
      }
    case types.GET_ORDINI_CODICE_PREVENTIVO:
      return {
        ...state,
        prezzo_sellout: action.payload.data.result.auto_prezzo_sellout,
        regime_iva: action.payload.data.result.auto_regime_iva,
        passaggio_proprieta_totale_generale:
          action.payload.data.result.auto_costo_passaggio_proprieta,
      }
    default:
      return state
  }
}

export const customer = function customer(state = {}, action) {
  switch (action.type) {
    case actions.REGISTRATION_EMAIL:
      const customer_updated = {
        ...state,
        registration_email: action.payload.new,
      }
      if (action.payload.new !== state.registration_email) {
        customer_updated.token = null
        customer_updated.id_cliente = null
        customer_updated.registration_lead = false
        customer_updated.newsletter_lead = false
      }
      return { ...state, ...customer_updated }
    case actions.CUSTOMER_TOKEN_CALLBACK:
    case types.POST_UTENTI_NLT_V1:
      return { ...state, token: action.payload.data.result.token }
    case actions.CUSTOMER_UPDATE:
      /**
       * la validazione durante
       * NLT richiede 18-75 anni
       */
      if ('data_di_nascita_nlt' in action.payload) {
        return {
          ...state,
          data_di_nascita: action.payload.data_di_nascita_nlt,
          data_di_nascita_nlt: action.payload.data_di_nascita_nlt,
        }
      }
      if ('data_di_nascita_findomestic' in action.payload) {
        return {
          ...state,
          data_di_nascita: action.payload.data_di_nascita_findomestic,
          data_di_nascita_findomestic:
            action.payload.data_di_nascita_findomestic,
        }
      }

      // se l'oggetto ha chiavi con valori assenti le ignoro
      const _customer = Object.keys(action.payload).reduce((acc, k) => {
        if (action.payload[k] !== null && action.payload[k] !== undefined) {
          acc[k] = action.payload[k]
        }

        return acc
      }, {})

      return { ...state, ..._customer }
    case types.PUT_CLIENTI_CALLBACK:
      return state
    case types.POST_CLIENTI_CALLBACK:
      return { ...state, id_cliente: action.payload.data.result }
    case types.TRACCIATO_SENT:
      return { ...state, tracciato_sent: true }
    case types.STORE_RESTORE_CALLBACK:
      const restoredCustomer = {
        ...action.payload.data.result.frontend.customer,
      }
      paddInPath(restoredCustomer, 'partita_iva', 11)
      paddInPath(restoredCustomer, 'cap_residenza', 5)
      paddInPath(restoredCustomer, 'cap_fatturazione', 5)
      paddInPath(restoredCustomer, 'cap_domicilio', 5)
      if (restoredCustomer.phone) {
        restoredCustomer.phone = `${restoredCustomer.phone}`
        if (
          !restoredCustomer.phone.startsWith('+') &&
          restoredCustomer.phone.length > 10
        ) {
          // duck fixing the json autocast to int of php
          restoredCustomer.phone = `+${restoredCustomer.phone}`
        }
      }
      return { ...state, ...restoredCustomer }
    case types.GET_ORDINI_CODICE_PREVENTIVO:
      const regimeChanged =
        action.payload.data.result.auto_regime_iva !==
        action.payload.data.result.stato_attuale_auto.regime_iva
      return {
        ...state,
        agevolazione_iva_104:
          action.payload.data.result.auto_regime_iva === 'Agevolato/minimo' &&
          regimeChanged,
      }
    case types.POST_CLIENTI_BRUMBRUM_V1:
      return {
        ...state,
        id_cliente_brumbrum: action.payload.data.result.id_cliente,
      }
    default:
      return state
  }
}

export const documentation = function documentation(state = {}, action) {
  switch (action.type) {
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.documentation,
      }
    default:
      return state
  }
}

export const privacy = function privacy(state = {}, action) {
  switch (action.type) {
    case actions.PRIVACY_UPDATE:
      return { ...state, ...action.payload }
    case actions.PUT_TRACCIATO_CALLBACK:
      return { ...state, ...action.payload.data.result }
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.privacy,
      }
    default:
      return state
  }
}

export const acceptance = function acceptance(state = {}, action) {
  switch (action.type) {
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.acceptance,
      }
    default:
      return state
  }
}

export const pricing = function pricing(state = {}, action) {
  switch (action.type) {
    case actions.NEW_DEFAULT_FINANCEMENTS_V4:
    case actions.NEW_DEFAULT_FINANCEMENTS_FINDOMESTIC:
      const maxMin = {
        importo_massimo_finanziabile:
          action.payload.data.result.importo_massimo_finanziabile,
        importo_minimo_finanziabile:
          action.payload.data.result.importo_minimo_finanziabile,
      }
      const stateResult = { ...state.data.result, ...maxMin }
      const stateData = { ...state.data, result: stateResult }
      return { ...state, data: stateData }
    case actions.NEW_PRODUCT_DETAILS:
      const oldResult = {
        ...state.data.result,
        ...action.payload.data.result,
      }
      const oldData = { ...state.data, result: oldResult }
      return { ...state, data: oldData }
    case actions.PRICING_UPDATE:
      return { ...state, ...action.payload }
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.pricing,
      }
    case types.GET_ORDINI_CODICE_PREVENTIVO:
      return { ...state, total: action.payload.data.result.totale }
    default:
      return state
  }
}

export const financements = function financements(state = [], action) {
  switch (action.type) {
    case actions.NEW_DEFAULT_FINANCEMENTS_FINDOMESTIC:
      const findomesticPayloadMapped = findomestic2compass(
        action.payload.data.result
      )

      return { ...state, default: findomesticPayloadMapped }
    case actions.NEW_DEFAULT_FINANCEMENTS:
      return { ...state, default: action.payload.data.result }

    case actions.NEW_DEFAULT_FINANCEMENTS_V4:
      const finanziamento_cms_v4_result = {
        ...action.payload.data.result,
      }

      if (
        finanziamento_cms_v4_result.presets &&
        finanziamento_cms_v4_result.presets.length > 0
      ) {
        const finanziamento_cms_v4 = finanziamento_cms_v4_result.presets.map(
          finanziamento => ({
            ...finanziamento,
            importo_massimo:
              finanziamento_cms_v4_result.importo_massimo_finanziabile,
            importo_minimo:
              finanziamento_cms_v4_result.importo_minimo_finanziabile,
          })
        )

        return { ...state, default: finanziamento_cms_v4 }
      }
      return state
    case actions.UPDATE_FINANCEMENTS_FINDOMESTIC_CUSTOM_CALC:
      const fpm = findomestic2compass(action.payload.data.result)
      return { ...state, custom: fpm[0] }
    case actions.UPDATE_FINANCEMENTS_COMPASS_CUSTOM_CALC:
      return { ...state, custom: action.payload.data.result }
    case actions.UPDATE_FINANCEMENTS:
      return { ...state, ...action.payload }
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.financements,
      }
    default:
      return state
  }
}

export const payment = function payment(state = null, action) {
  switch (action.type) {
    case actions.PAYMENT_METHOD_SELECTED:
      return { ...state, ...action.payload }
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.payment,
      }
    default:
      return state
  }
}

export const ordine = function ordine(state = null, action) {
  switch (action.type) {
    case actions.FINANZIAMENTO_SELECTED:
      return {
        ...state,
        id_finanziamento: action.payload.payload.id_finanziamento,
      }
    case types.NEW_ORDINE:
    case types.GET_ORDINE_AFTER_RESTORE:
    case types.POST_ORDINI_NTL_V1:
      const resultPayload = { ...action.payload.data.result }
      // FIXME va corretta la api di ordini deve sempre rispondere alla stessa maniera
      if (resultPayload.servizi_extra && resultPayload.servizi_extra.usato) {
        resultPayload.servizi_extra.ordini_servizi =
          resultPayload.servizi_extra.usato
        delete resultPayload.servizi_extra.usato
      }

      if (
        resultPayload.servizi_extra &&
        resultPayload.servizi_extra.ordini_servizi &&
        typeof resultPayload.servizi_extra.ordini_servizi.map === 'function'
      ) {
        resultPayload.servizi_extra.ordini_servizi =
          resultPayload.servizi_extra.ordini_servizi.map(ordini_servizio => {
            ordini_servizio.prezzo_listino = ordini_servizio.prezzo
            ordini_servizio.prezzo -= ordini_servizio.sconto
            return ordini_servizio
          })
      }

      if (
        resultPayload.transazione &&
        resultPayload.transazione.pagamenti &&
        resultPayload.transazione.pagamenti.length
      ) {
        const acconti = resultPayload.transazione.pagamenti.reduce(
          (acc, pagamento) => acc + pagamento.totale_effettivo,
          0
        )
        const withAcconti = { ...resultPayload, acconti }
        return { ...state, ...withAcconti }
      }
      const withoutAcconti = { ...resultPayload, acconti: 0 }
      return { ...state, ...withoutAcconti }
    case actions.UPDATE_ORDINE:
      return { ...state, ...action.payload }
    case types.STORE_RESTORE_CALLBACK:
      const ordineRestore = action.payload.data.result.frontend.ordine
      if (ordineRestore.transazione && ordineRestore.transazione.pagamenti) {
        const acconti = ordineRestore.transazione.pagamenti.reduce(
          (acc, pagamento) => acc + pagamento.totale_effettivo,
          0
        )
        const withAcconti = { ...ordineRestore, acconti }
        return { ...state, ...withAcconti }
      }
      return { ...state, withoutAcconti: { ...ordineRestore, acconti: 0 } }
    case actions.REGISTRATION_EMAIL:
      const ordine_updated = { ...state }
      if (action.payload.new !== action.payload.old) {
        ordine_updated.id_ordine = null
        ordine_updated.id_finanziamento = null
      }
      return { ...state, ...ordine_updated }
    case types.SET_CODICE_PREVENTIVO:
      return { ...state, codice_preventivo: action.payload }
    case types.GET_ORDINI_CODICE_PREVENTIVO:
      return {
        ...state,
        transazione: action.payload.data.result.transazione,
        acconti:
          action.payload.data.result.transazione &&
          action.payload.data.result.transazione.pagamenti
            ? action.payload.data.result.transazione.pagamenti.reduce(
                (acc, pagamento) => acc + pagamento.totale_effettivo,
                0
              )
            : 0,
        sconto: action.payload.data.result.sconto,
        totale: action.payload.data.result.totale,
        costi_extra: action.payload.data.result.costi_extra,
        codice_preventivo:
          action.payload.data.result.codice_preventivo ||
          state.codice_preventivo,
        minicart_label:
          action.payload.data.result.minicart_label ||
          state.minicart_label ||
          '',
        preventivo_confermato: true,
      }
    case actions.REGISTRATION_LEAD:
      return { ...state, id_evento: action.payload.data.result.id_evento }
    case types.POST_FINDOMESTIC_SET_PRATICA:
      const success =
        action.payload.response_details &&
        action.payload.response_details.status === 200

      if (success) {
        const updateData = JSON.parse(action.payload.payload.body)
        const idFinanziamentoAssicurato = updateData.id_finanziamento
        return {
          ...state,
          id_finanziamento: idFinanziamentoAssicurato,
          id_finanziamento_non_assicurato: state.id_finanziamento,
        }
      }

      return state
    case types.GET_ORDINI_SERVIZI_AGGIUNTIVI_V1:
      const { result } = action.payload.data
      const domain_list = []
      const available_list = result.available_list.reduce((current, el) => {
        const domain = {
          id: el.id,
          titolo: el.name,
          descrizione: el.description,
        }

        domain_list.push(domain)

        for (const service of el.services) {
          service.domain_id = el.id
          current.push(service)
        }

        return current
      }, [])

      return {
        ...state,
        domini_servizi_aggiuntivi_disponibili: domain_list,
        servizi_aggiuntivi_disponibili: available_list.map(elem => {
          const prezzo = elem.discount_prices.reduce(
            (current, el) => current - el.price,
            elem.price.price
          )

          return {
            titolo: elem.name,
            descrizione: elem.description,
            prezzo: prezzo >= 0 ? prezzo : elem.price.price,
            prezzo_listino: elem.price.price,
            id_dominio: elem.domain_id,
            id_servizio: elem.external_id,
            id_vas: elem.id,
          }
        }),
      }
    case types.SERVIZI_AGGIUNTIVI_NORMALIZE_SELECTED:
      if (
        !state.servizi_extra.ordini_servizi?.length ||
        !state.servizi_aggiuntivi_disponibili.length
      ) {
        return { ...state }
      }

      for (const normalizedVas of state.servizi_extra.ordini_servizi) {
        const availableVas = state.servizi_aggiuntivi_disponibili.find(
          el => normalizedVas.id_servizio === el.id_servizio
        )

        normalizedVas.id_vas = availableVas.id_vas
        normalizedVas.id_dominio = availableVas.id_dominio
      }

      return { ...state }
    case types.SERVIZI_AGGIUNTIVI_SELECTED_SERVIZIO:
      const prevSelected = state.servizi_extra.ordini_servizi || []

      if (
        !prevSelected.find(el => el.id_servizio === action.payload.id_servizio)
      ) {
        prevSelected.push(action.payload)
      }

      return {
        ...state,
        totale: state.totale + action.payload.prezzo,
        servizi_extra: {
          ordini_servizi: prevSelected,
        },
      }
    case types.SERVIZI_AGGIUNTIVI_UNSELECTED_SERVIZIO:
      const prevSelectedd = state.servizi_extra.ordini_servizi || []
      remove(
        prevSelectedd,
        element => element.id_servizio === action.payload.id_servizio
      )
      return {
        ...state,
        totale: state.totale - action.payload.prezzo,
        servizi_extra: {
          ordini_servizi: prevSelectedd,
        },
      }
    case types.SERVIZI_AGGIUNTIVI_UNSELECT_ALL:
      const prevSelecteddd = state.servizi_extra.ordini_servizi || []
      const prevSelectedddTotalCost = prevSelecteddd.reduce(
        (acc, ss) => (acc += ss.prezzo),
        0
      )
      return {
        ...state,
        totale: state.totale - prevSelectedddTotalCost,
        servizi_extra: {
          ordini_servizi: [],
        },
      }
    default:
      return state
  }
}

export const secci = function secci(state = null, action) {
  switch (action.type) {
    case actions.NEW_SECCI:
      return { ...state, ...action.payload.data.result }
    case actions.UPDATE_SECCI:
      return { ...state, ...action.payload }
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.secci,
      }
    default:
      return state
  }
}

export const compass = function compass(state = null, action) {
  switch (action.type) {
    case actions.COMPASS_UPDATE:
      return { ...state, ...action.payload }
    case types.STORE_RESTORE_CALLBACK:
      const restoredCompass = {
        ...action.payload.data.result.frontend.compass,
      }
      paddInPath(restoredCompass, 'cap_lavoro', 5)
      return { ...state, ...restoredCompass }
    default:
      return state
  }
}

export const compass_tabelledominio = function compass_tabelledominio(
  state = null,
  action
) {
  switch (action.type) {
    case types.GET_TABELLE_DOMINIO_COMPASS_CALLBACK_CITTADINANZA:
      // BRUM-1633 inibisce questo, vedi sotto
      return state
    case types.GET_TABELLE_DOMINIO_COMPASS_CALLBACK_OCCUPAZIONEATTIVITA:
      return { ...state, occupazioneattivita: action.payload.data.result }
    case types.GET_TABELLE_DOMINIO_COMPASS_CALLBACK_SETTOREATTIVITA:
      return { ...state, settoreattivita: action.payload.data.result }
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.compass_tabelledominio,
      }
    case actions.NEW_NAZIONI:
      /**
       * BRUM-1633 agisco sullo store senza cambiare il resto
       * in questo caso in action.payload.data.result ho
       * {
            "descrizione": "italiana",
            "flagExtracomunitaria": "no",
            "iso": "ITA",
            "nazione": "Italia"
          }
       * da /comuni/p/v1/list/nazioni/complete/all
       * compass.codice >>> comuni.iso
       * compass.descrizione >>> comuni.descrizione
       * compass.nazione >>> comuni.nazione
       * compass.flagExtracomunitaria >>> comuni.flagExtracomunitaria
       */
      const cittadinanza_is_extra_eu_by_codice = {}
      const cittadinanza = action.payload.data.result.map(o => {
        // FIXME WIP comuni per adesso non ha flagExtracomunitaria
        cittadinanza_is_extra_eu_by_codice[o.iso] =
          o.flagExtracomunitaria !== 'no'
        return { label: o.descrizione, value: `${o.iso}|${o.descrizione}` }
      })
      return { ...state, cittadinanza, cittadinanza_is_extra_eu_by_codice }
    case types.SEARCH_COMUNI_CITTADINANZA:
      const searchCittadinanza = transformComuniCittadinanzaV2Result(
        action.payload.data.result
      )
      return {
        ...state,
        cittadinanza: unionWith(
          state.cittadinanza,
          searchCittadinanza.cittadinanza,
          isEqual
        ),
        cittadinanza_is_extra_eu_by_codice: merge(
          state.cittadinanza_is_extra_eu_by_codice,
          searchCittadinanza.cittadinanza_is_extra_eu_by_codice
        ),
      }
    default:
      return state
  }
}

export const compassFileUpload = function compassFileUpload(
  state = null,
  action
) {
  switch (action.type) {
    case actions.GET_COMPASS_DOCUMENTI_LIST_CALLBACK:
      return { ...state, documenti_necessari: action.payload.data.result }
    case types.COMPASS_FILE_UPLOAD_DROPPED:
      const dropzone = [].concat([], state.dropzone, action.payload.dropzone)
      const new_state = { ...state, dropzone }
      return new_state
    case types.COMPASS_FILE_UPLOAD_REMOVED:
      const removed_state = { ...state }
      removed_state.dropzone.splice(parseInt(action.payload), 1)
      return removed_state
    case types.STORE_RESTORE_CALLBACK:
      /**
       * FIXME BRUM-340 non si avranno gli oggetti file con dentro i blob ma solo i meta
       * che fare?!
       */
      return {
        ...state,
        ...action.payload.data.result.frontend.compassFileUpload,
      }
    default:
      return state
  }
}

export const bonificoFileUpload = function bonificoFileUpload(
  state = null,
  action
) {
  switch (action.type) {
    case types.BONIFICO_FILE_UPLOAD_DROPPED:
      const dropzone = [].concat([], state.dropzone, action.payload.dropzone)
      const new_state = { ...state, dropzone }
      return new_state
    case types.BONIFICO_FILE_UPLOAD_REMOVED:
      const removed_state = { ...state }
      removed_state.dropzone.splice(parseInt(action.payload), 1)
      return removed_state
    case types.STORE_RESTORE_CALLBACK:
      /**
       * FIXME BRUM-340 non si avranno gli oggetti file con dentro i blob ma solo i meta
       * che fare?!
       */
      return {
        ...state,
        ...action.payload.data.result.frontend.bonificoFileUpload,
      }
    default:
      return state
  }
}

export const findomesticFileUpload = function findomesticFileUpload(
  state = null,
  action
) {
  switch (action.type) {
    case types.FINDOMESTIC_FILE_UPLOAD_DROPPED:
      const dropzone = [].concat([], state.dropzone, action.payload.dropzone)
      const new_state = { ...state, dropzone }
      return new_state
    case types.FINDOMESTIC_FILE_UPLOAD_REMOVED:
      const removed_state = { ...state }
      removed_state.dropzone.splice(parseInt(action.payload), 1)
      return removed_state
    case types.STORE_RESTORE_CALLBACK:
      /**
       * FIXME BRUM-340 non si avranno gli oggetti file con dentro i blob ma solo i meta
       * che fare?!
       */
      return {
        ...state,
        ...action.payload.data.result.frontend.findomesticFileUpload,
      }
    default:
      return state
  }
}

export const distintaFileUpload = function distintaFileUpload(
  state = null,
  action
) {
  switch (action.type) {
    case types.DISTINTA_FILE_UPLOAD_DROPPED:
      const dropzone = [].concat([], state.dropzone, action.payload.dropzone)
      return { ...state, dropzone }
    case types.STORE_RESTORE_CALLBACK:
      /**
       * FIXME BRUM-340 non si avranno gli oggetti file con dentro i blob ma solo i meta
       * che fare?!
       */
      return {
        ...state,
        ...action.payload.data.result.frontend.distintaFileUpload,
      }
    default:
      return state
  }
}

export const comuni = function comuni(
  state = { comune: [], nazione: [] },
  action
) {
  switch (action.type) {
    case actions.NEW_COMUNI:
      const comune = action.payload.data.result.map(o => ({
        label: `${o.comune} (${o.codice_provincia})`,
        value: `${o.comune}|${o.codice_provincia}|ITA|${o.comune} (${
          o.codice_provincia
        })|${o.zip.join('|')}|${o.land_register}`,
      }))
      return { ...state, comune }

    case actions.NEW_NAZIONI:
      const nazione = action.payload.data.result.map(o => ({
        label: `${o.nazione} (EE)`,
        value: `null|EE|${o.iso}|${o.nazione} (EE)|${o.land_register}`,
      }))
      return { ...state, nazione }
    case types.SEARCH_COMUNI_LUOGO_NASCITA:
      const searchLuogoNascita = transformComuniV2Result(
        action.payload.data.result
      )
      return {
        ...state,
        searchLuogoNascita: unionWith(
          state.searchLuogoNascita,
          searchLuogoNascita,
          isEqual
        ),
      }
    case types.SEARCH_COMUNI_CITTADINANZA:
      const searchCittadinanza = transformComuniCittadinanzaV2Result(
        action.payload.data.result
      )

      return {
        ...state,
        searchCittadinanza: {
          cittadinanza: unionWith(
            state.searchCittadinanza.cittadinanza,
            searchCittadinanza.cittadinanza,
            isEqual
          ),
          cittadinanza_is_extra_eu_by_codice: merge(
            state.searchCittadinanza.cittadinanza_is_extra_eu_by_codice,
            searchCittadinanza.cittadinanza_is_extra_eu_by_codice
          ),
        },
      }

    case types.SEARCH_LUOGO_EMISSIONE_PATENTE:
      const searchPatente = transformLicenseV2Result(action.payload.data.result)

      return { ...state, searchLuogoEmissionePatente: searchPatente }

    case types.SEARCH_LUOGO_EMISSIONE_CARTAIDENTITA:
      const searchCarta = transformIdentityCardV2Result(
        action.payload.data.result
      )

      return { ...state, searchLuogoEmissioneCartaIdentita: searchCarta }

    case types.SEARCH_LUOGO_EMISSIONE_PASSAPORTO:
      const searchPassaporto = transformPassportV2Result(
        action.payload.data.result
      )

      return { ...state, searchLuogoEmissionePassaporto: searchPassaporto }

    case types.SEARCH_COMUNI_RESIDENZA:
      const searchComuneResidenza = transformComuniResidenzaV2Result(
        action.payload.data.result
      )

      return {
        ...state,
        searchComuneResidenza: unionWith(
          state.searchComuneResidenza,
          searchComuneResidenza,
          isEqual
        ),
      }
    default:
      return state
  }
}

export const error = function error(state = null, action) {
  switch (action.type) {
    case types.GET_FINDOMESTIC_SERVIZI_ASSICURATIVI:
    case types.GET_FINDOMESTIC_PRODOTTI_ASSICURATIVI_FROM_ID_PIANO_RIMBORSO_OUTPUT:
      try {
        // eslint-disable-next-line
        action.payload.data.result.map(s => {
          if (!s.questionario_adeguatezza) {
            throw new Error('Questionario adeguatezza assente.')
          } else if (typeof s.questionario_adeguatezza === 'string') {
            try {
              s.questionario_adeguatezza = JSON.parse(
                s.questionario_adeguatezza
              )
            } catch (e) {
              throw new Error(
                `Errore nel recupero del questionario di adeguatezza: ${e.message}`
              )
            }
          }

          if (
            s.questionario_medico &&
            typeof s.questionario_medico === 'string'
          ) {
            try {
              JSON.parse(s.questionario_medico)
            } catch (e) {
              throw new Error(
                `Errore nel recupero del questionario medico: ${e.message}`
              )
            }
          }
        })
      } catch (e) {
        return {
          ...state,
          display: true,
          type: 'custom',
          message: e.message,
          title: 'Errore interno',
          logo: 'generic_logo',
          closable: false,
          xray: action.payload.response_details.xray,
          brum_session_id: action.payload.response_details.brum_session_id,
          selloutCallHash: action.payload.response_details.selloutCallHash,
        }
      }

      return state
    case types.CLOSE_SLACK_POPUP:
      return { ...state, display: false }
    case types.ERROR_NOTICE:
      return {
        ...state,
        ...action.payload,
        display: true,
        type: action.payload.type,
      }
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.error,
      }
    case actions.NEW_DEFAULT_FINANCEMENTS_V4:
      // BRUM-9376 disabilita il messaggio di errore
      // in caso di mancati finanziamenti
      return state
    default:
      return state
  }
}

export const transazioni = function transazioni(state = null, action) {
  switch (action.type) {
    case actions.POST_TRANSAZIONI_ADD_PARAMETRO_CALLBACK:
      let new_state = action.payload.data.result
      if (typeof new_state === 'string') {
        try {
          new_state = JSON.parse(action.payload.data.result)
        } catch (e) {
          new_state = {
            message_add_parametro_callback: new_state,
          }
        }
      }
      return { ...state, ...new_state }
    case actions.POST_TRANSAZIONI_ADD_CALLBACK:
      let _new_state = action.payload.data.result
      if (typeof _new_state === 'string') {
        try {
          _new_state = JSON.parse(action.payload.data.result)
        } catch (e) {
          _new_state = {
            message_add_callback: _new_state,
          }
        }
      }
      return { ...state, ..._new_state }
    case actions.TRANSAZIONI_UPDATE:
      return { ...state, ...action.payload }
    case types.GET_TRANSAZIONI_IBAN:
      return { ...state, conti: action.payload.data.result }
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.transazioni,
      }
    default:
      return state
  }
}

const TipologiaConsegna = {
  SPEDIZIONE: 'Spedizione',
  RITIRO_GARAGE: 'Ritiro in garage',
  CONSEGNA_CASA: 'Consegna a casa',
}

export const logistica = function logistica(state = null, action) {
  switch (action.type) {
    case types.NEW_LOGISTICA_CENTRI_CONVENZIONATI:
      const centri_convenzionati = action.payload.data.result
      const centri_convenzionti_by_city = centri_convenzionati.reduce(
        (obj, centro_convenzionato) => {
          obj[centro_convenzionato.nome] = centro_convenzionato
          return obj
        },
        {}
      )

      const centri_convezionati_by_id = {}
      centri_convenzionati.forEach(cc => {
        centri_convezionati_by_id[cc.id] = cc
      })

      // BRUM-9771 selezionamo di default il primo centro convenzionato
      const centro_convenzionato = undefined
      /* BRUM-11987 non vogliamo piu' un centro di consegna selezionato di default
        centri_convenzionti_by_city[
          Object.keys(centri_convenzionti_by_city)[0]
          ] */
      const centri_convenzionati_by_codice_provincia = {}
      centri_convenzionati.forEach(cc => {
        centri_convenzionati_by_codice_provincia[cc.codice_provincia] = cc
      })
      const centri_convenzionati_by_provincia = {}
      centri_convenzionati.forEach(cc => {
        const tipologia_consegna = cc.tipologia_consegna
        const provincia = cc.codice_provincia
        if (!(provincia in centri_convenzionati_by_provincia)) {
          centri_convenzionati_by_provincia[provincia] = {
            label: cc.nome_provincia,
            value: cc.codice_provincia,
            modalita: [cc],
          }
        } else {
          centri_convenzionati_by_provincia[provincia].modalita.push(cc)
        }
        if (
          [
            TipologiaConsegna.SPEDIZIONE,
            TipologiaConsegna.RITIRO_GARAGE,
          ].includes(tipologia_consegna)
        ) {
          cc.province_servite.forEach(ccc => {
            if (!(ccc.provincia in centri_convenzionati_by_provincia)) {
              centri_convenzionati_by_provincia[ccc.provincia] = {
                label:
                  centri_convenzionati_by_codice_provincia[ccc.provincia]
                    .nome_provincia,
                value:
                  centri_convenzionati_by_codice_provincia[ccc.provincia]
                    .codice_provincia,
                modalita: [cc],
              }
            } else {
              centri_convenzionati_by_provincia[ccc.provincia].modalita.push(cc)
            }
          })
        }
      })
      const codice_provincia_default = null
      return {
        ...state,
        centri_convezionati: centri_convenzionti_by_city,
        centro_convenzionato,
        centri_convenzionati_by_provincia,
        codice_provincia: codice_provincia_default,
      }
    case types.SET_COMPASS_CALCOLATRICE_LOGISTICA:
      return { ...state, ...action.payload }
    case types.SET_LOGISTICA_CENTRO_CONVENZIONATO:
      return { ...state, centro_convenzionato: action.payload }
    case types.SET_LOGISTICA_CODICE_PROVINCIA:
      return { ...state, codice_provincia: action.payload }
    case types.STORE_RESTORE_CALLBACK:
      return {
        ...state,
        ...action.payload.data.result.frontend.logistica,
      }
    default:
      return state
  }
}

export const findomestic = function findomestic(state = null, action) {
  switch (action.type) {
    case types.FINDOMESTIC_CODICI_ABITAZONE:
      const CodiciAbitazione = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, CodiciAbitazione }
    case types.FINDOMESTIC_CODICI_CARTA:
      const CodiciCarta = action.payload.data.result
      return { ...state, CodiciCarta }
    case types.FINDOMESTIC_CODICI_DESTINATARIO:
      const CodiciDestinatario = action.payload.data.result
      return { ...state, CodiciDestinatario }
    case types.FINDOMESTIC_CODICI_DOCUMENTO:
      const CodiciDocumento = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, CodiciDocumento }
    case types.FINDOMESTIC_CODICI_NAZIONALITA:
      const CodiciNazionalita = action.payload.data.result
      return { ...state, CodiciNazionalita }
    case types.FINDOMESTIC_CODICI_PAGAMENTO:
      const CodiciPagamento = action.payload.data.result
      return { ...state, CodiciPagamento }
    case types.FINDOMESTIC_CODICI_REPERIBILITA:
      const CodiciReperibilita = action.payload.data.result
      return { ...state, CodiciReperibilita }
    case types.FINDOMESTIC_CODICI_SCADENZA:
      const CodiciScadenza = action.payload.data.result
      return { ...state, CodiciScadenza }
    case types.FINDOMESTIC_CODICI_STATOCIVILE:
      const CodiciStatoCivile = action.payload.data.result.map(element => ({
        label: element.descrizione,
        value: element.codice,
      }))
      return { ...state, CodiciStatoCivile }
    case types.FINDOMESTIC_CODICI_TIPOASSICURAZIONE:
      const CodiciTipoAssicurazione = action.payload.data.result
      return { ...state, CodiciTipoAssicurazione }
    case types.FINDOMESTIC_CODICI_TIPODOCUMENTOSOGGIORNO:
      const CodiciTipoDocumentoSoggiorno = action.payload.data.result
      return { ...state, CodiciTipoDocumentoSoggiorno }
    case types.FINDOMESTIC_CODICI_TIPOLAVORO:
      /**
       * BRUM-5062 dentro questa response ho
       * tutti i livelli di tipo lavoro
       * - situazione lavorativa
       * - settore autonomi
       * - attivita impiego
       */
      const { result } = action.payload.data
      const settoreBySituazione = {}
      // per ogni lavoro associo i settori
      result.map(lavoro => {
        const parent1 = trim(lavoro.parent_1)
        if (!settoreBySituazione[parent1]) {
          settoreBySituazione[parent1] = []
        }
        settoreBySituazione[parent1].push(trim(lavoro.parent_2))
        return null
      })
      // trasformo i settori in oggetti per le dropdown label,value
      const settoriKeys = Object.keys(settoreBySituazione)
      settoriKeys.map(settoriKey => {
        const _settoriKey = trim(settoriKey)
        const settori = uniq(settoreBySituazione[_settoriKey])
        const settoreValues = settori.map(settore => ({
          label: trim(settore),
          value: trim(settore),
        }))
        settoreBySituazione[_settoriKey] = settoreValues
        return null
      })

      const occupazioneBySituazioneAndSettore = {}
      // per ogni lavoro associo le occupazioni
      result.map(lavoro => {
        const situazioneAndSettore = `${trim(lavoro.parent_1)}_${trim(
          lavoro.parent_2
        )}`
        if (!occupazioneBySituazioneAndSettore[situazioneAndSettore]) {
          occupazioneBySituazioneAndSettore[situazioneAndSettore] = []
        }
        occupazioneBySituazioneAndSettore[situazioneAndSettore].push(
          trim(lavoro.descrizione)
        )
        return null
      })
      // trasformo le occupazioni in oggetti per le dropdown label,value
      const situazioneAndSettoreKeys = Object.keys(
        occupazioneBySituazioneAndSettore
      )
      situazioneAndSettoreKeys.map(situazioneAndSettoreKey => {
        const occupazioni = uniq(
          occupazioneBySituazioneAndSettore[trim(situazioneAndSettoreKey)]
        )
        const occupazioniValues = occupazioni.map(occupazione => ({
          label: trim(occupazione),
          value: trim(occupazione),
        }))
        occupazioneBySituazioneAndSettore[trim(situazioneAndSettoreKey)] =
          occupazioniValues
        return null
      })

      // uso spregiudicato della map
      const situazioneLavorativa = uniq(
        result.map(lavoro => trim(lavoro.parent_1))
      ).map(lavoro => ({
        label: trim(lavoro),
        value: trim(lavoro),
      }))

      const CodiciTipoLavoro = result
      return {
        ...state,
        CodiciTipoLavoro,
        situazioneLavorativa,
        settoreBySituazione,
        occupazioneBySituazioneAndSettore,
      }
    case types.FINDOMESTIC_CODICI_TIPOVEICOLO:
      const CodiciTipoVeicolo = action.payload.data.result
      return { ...state, CodiciTipoVeicolo }
    case types.FINDOMESTIC_CODICI_TITOLOSTUDIO:
      const CodiciTitoloStudio = action.payload.data.result
      return { ...state, CodiciTitoloStudio }
    case types.FINDOMESTIC_MAPPA_CODICI_LAVORO_SETTORI_ATTIVITA:
      const MappaCodiciLavoroSettoriAttivita = action.payload.data.result
      return { ...state, MappaCodiciLavoroSettoriAttivita }
    case types.FINDOMESTIC_CODICI_SETTORE_ATTIVITA:
      const CodiciSettoreAttivita = action.payload.data.result
      const CodiciSettoreAttivitaById = action.payload.data.result.reduce(
        (acc, current) => {
          acc[current.id] = current
          return acc
        },
        []
      )
      return { ...state, CodiciSettoreAttivita, CodiciSettoreAttivitaById }
    case types.FINDOMESTIC_UPDATE_DATI:
      const currentDati = state.dati
      const actionData = { ...action.payload }

      /**
       * Gestice il reset delle tendine
       * della sezione lavoro
       */
      if (actionData.situazione_lavorativa === '') {
        actionData.settore = ''
      }
      if (actionData.settore === '') {
        actionData.occupazione = ''
      }

      if (actionData.coniuge_situazione_lavorativa === '') {
        actionData.coniuge_settore = ''
      }
      if (actionData.coniuge_settore === '') {
        actionData.coniuge_occupazione = ''
      }

      const _sl = actionData.situazione_lavorativa
      if (_sl !== '') {
        if (
          state.settoreBySituazione[_sl] &&
          state.settoreBySituazione[_sl].length === 1
        ) {
          actionData.settore = state.settoreBySituazione[_sl][0].value
        }
        const situazioneAndSettore = `${_sl}_${actionData.settore}`
        if (
          state.occupazioneBySituazioneAndSettore[situazioneAndSettore] &&
          state.occupazioneBySituazioneAndSettore[situazioneAndSettore]
            .length === 1
        ) {
          actionData.occupazione =
            state.occupazioneBySituazioneAndSettore[
              situazioneAndSettore
            ][0].value
        }
      }

      const slConiuge = actionData.coniuge_situazione_lavorativa
      if (slConiuge !== '') {
        if (
          state.settoreBySituazione[slConiuge] &&
          state.settoreBySituazione[slConiuge].length === 1
        ) {
          actionData.coniuge_settore =
            state.settoreBySituazione[slConiuge][0].value
        }
        const situazioneAndSettoreConiuge = `${slConiuge}_${actionData.coniuge_settore}`
        if (
          state.occupazioneBySituazioneAndSettore[
            situazioneAndSettoreConiuge
          ] &&
          state.occupazioneBySituazioneAndSettore[situazioneAndSettoreConiuge]
            .length === 1
        ) {
          actionData.coniuge_occupazione =
            state.occupazioneBySituazioneAndSettore[
              situazioneAndSettoreConiuge
            ][0].value
        }
      }

      const newDati = { ...currentDati, ...actionData }
      return { ...state, dati: newDati }
    case types.POST_FINDOMESTIC_DATI_CLIENTE_V1:
      const _currentDati = state.dati
      const idCliente = action.payload.data.result.id_cliente
      const _newDati = { ..._currentDati, idCliente }
      return { ...state, dati: _newDati }
    case types.GET_FINDOMESTIC_DOCUMENTI_CLIENTE_V1:
      return { ...state, documenti_necessari: action.payload.data.result }
    case types.FINDOMESTIC_UPDATE:
      return { ...state, ...action.payload }
    case types.STORE_RESTORE_CALLBACK:
      const restoreData = action.payload.data.result.frontend.findomestic
      const safeDefaults = {
        pin: '',
        conferma_pin: '',
        otp: '',
        certificatoLinks: [],
        certificatoCheckBoxes: {},
        contrattoInfocertLinks: [],
        contrattoInfocertCheckBoxes: {},
        contrattoFindomesticLinks: [],
        contrattoFindomesticCheckBoxes: {},
      }
      const safeRestoreData = { ...restoreData, ...safeDefaults }
      paddInPath(safeRestoreData, 'dati.cap_precedente', 5)
      paddInPath(safeRestoreData, 'dati.cap_lavoro', 5)

      return { ...state, ...safeRestoreData }
    case types.GET_FINDOMESTIC_CHECK_FIRMA:
      const { can_sign } = action.payload.data.result
      return { ...state, can_sign }
    case types.GET_FINDOMESTIC_CHECK_FIRMA_V2:
      const can_sign_v2 = action.payload.data.result.can_sign
      return { ...state, can_sign_v2 }
    case types.GET_INFOCERT_CERTIFICATO:
    case types.GET_INFOCERT_CERTIFICATO_V2:
      const certificatoLinks = action.payload.data.result.links
      const { credentials } = action.payload.data.result
      const certificatoCheckBoxes = merge(
        {},
        state.certificatoCheckBoxes,
        mapValues(action.payload.data.result.checkboxes, check => {
          // le checkbox nascoste devono risultare subito selezionate
          const _check = check
          if (_check.hidden) {
            _check.accepted = true
          }
          return _check
        })
      )

      const _contrattoFindomesticCheckBoxes = merge(
        {},
        state.contrattoFindomesticCheckBoxes,
        mapValues(action.payload.data.result.findomestic.checkboxes, check => {
          // le checkbox nascoste devono risultare subito selezionate
          const _check = check
          if (_check.hidden) {
            _check.accepted = true
          }
          return _check
        })
      )

      const firmaAssicurazioni = Object.keys(
        action.payload.data.result.assicurazioni
      ).map(assKey => {
        const ass = action.payload.data.result.assicurazioni[assKey]
        return {
          key: assKey,
          codice: ass.codice,
          titolo: ass.titolo,
          descrizione: ass.descrizione,
          link_informativa: ass.link_informativa,
        }
      })
      const firmaAssicurazioniCheckBoxes = Object.keys(
        action.payload.data.result.assicurazioni
      ).reduce((acc, assKey) => {
        const ass = action.payload.data.result.assicurazioni[assKey]
        const checkboxes = {}
        // eslint-disable-next-line
        Object.keys(ass.checkboxes).map(checkKey => {
          const cb = ass.checkboxes[checkKey]
          cb.key = `${assKey}_${checkKey}`
          checkboxes[cb.key] = cb
        })

        return { ...acc, ...checkboxes }
      }, {})

      return {
        ...state,
        firmaAssicurazioni,
        firmaAssicurazioniCheckBoxes,
        certificatoLinks,
        certificatoCheckBoxes,
        credentials,
        meta: action.payload.data.result.meta,
        contrattoFindomesticCheckBoxes: _contrattoFindomesticCheckBoxes,
        certificatoInfocertStepAbstract:
          action.payload.data.result.stepAbstract,
      }
    case types.RESET_FINDOMESTIC_PIN:
      return {
        ...state,
        pin: '',
        conferma_pin: '',
        otp: '',
        credentials: {},
        can_sign: false,
        certificatoLinks: [],
        certificatoCheckBoxes: {},
        contrattoInfocertLinks: [],
        contrattoInfocertCheckBoxes: {},
        contrattoFindomesticLinks: [],
        contrattoFindomesticCheckBoxes: {},
      }
    case types.FINDOMESTIC_CHECKBOX_ASSICURAZIONI:
      const checkBoxAssicurazione = action.payload.name
      const oldCheckBoxAssicurazione =
        state.firmaAssicurazioniCheckBoxes[checkBoxAssicurazione]
      const newCheckBoxAssicurazione = {}
      newCheckBoxAssicurazione[checkBoxAssicurazione] = {
        ...oldCheckBoxAssicurazione,
        accepted: action.payload.accepted,
      }
      const _firmaAssicurazioniCheckBoxes = {
        ...state.firmaAssicurazioniCheckBoxes,
        ...newCheckBoxAssicurazione,
      }
      return {
        ...state,
        firmaAssicurazioniCheckBoxes: _firmaAssicurazioniCheckBoxes,
      }
    case types.FINDOMESTIC_CHECKBOX_CONTRATTO:
      const checkBoxContratto = action.payload.name
      const __accepted = action.payload.accepted
      const oldCheckBoxContratto =
        state.contrattoFindomesticCheckBoxes[checkBoxContratto]
      const newCheckBoxContratto = {}
      newCheckBoxContratto[checkBoxContratto] = {
        ...oldCheckBoxContratto,
        accepted: __accepted,
      }
      const findomesticCheckBoxes = {
        ...state.contrattoFindomesticCheckBoxes,
        ...newCheckBoxContratto,
      }
      return { ...state, contrattoFindomesticCheckBoxes: findomesticCheckBoxes }
    case types.INFOCERT_CHECKBOX_CERTIFICATO:
      const checkBoxCertificato = action.payload.name
      const { accepted } = action.payload
      const oldCheckBoxCertificato =
        state.certificatoCheckBoxes[checkBoxCertificato]
      const newCheckBoxCertificato = {}
      newCheckBoxCertificato[checkBoxCertificato] = {
        ...oldCheckBoxCertificato,
        accepted,
      }
      const _certificatoCheckBoxes = {
        ...state.certificatoCheckBoxes,
        ...newCheckBoxCertificato,
      }
      return { ...state, certificatoCheckBoxes: _certificatoCheckBoxes }
    case types.INFOCERT_CHECKBOX_CONTRATTO:
      const _checkBoxContratto = action.payload.name
      const _accepted = action.payload.accepted
      const _oldCheckBoxContratto =
        state.contrattoInfocertCheckBoxes[_checkBoxContratto]
      const _newCheckBoxContratto = {}
      _newCheckBoxContratto[_checkBoxContratto] = {
        ..._oldCheckBoxContratto,
        accepted: _accepted,
      }
      const infocertCheckBoxes = {
        ...state.contrattoInfocertCheckBoxes,
        ..._newCheckBoxContratto,
      }
      return { ...state, contrattoInfocertCheckBoxes: infocertCheckBoxes }
    case types.GET_FINDOMESTIC_FIRMA_CONTRATTI:
    case types.POST_INFOCERT_CERTIFICATO_V2:
      const { infocert } = action.payload.data.result
      const _findomestic = action.payload.data.result.findomestic

      const contrattoInfocertLinks = infocert
        ? infocert.links
        : state.contrattoInfocertLinks
      const contrattoInfocertCheckBoxes = infocert
        ? merge(
            {},
            state.contrattoInfocertCheckBoxes,
            mapValues(infocert.checkboxes, check => {
              // le checkbox nascoste devono risultare subito selezionate
              const _check = check
              if (_check.hidden) {
                _check.accepted = true
              }
              return _check
            })
          )
        : state.contrattoInfocertCheckBoxes

      const contrattoFindomesticLinks = _findomestic
        ? _findomestic.links
        : state.contrattoFindomesticLinks
      const contrattoFindomesticCheckBoxes = _findomestic
        ? merge(
            {},
            state.contrattoFindomesticCheckBoxes,
            mapValues(_findomestic.checkboxes, check => {
              // le checkbox nascoste devono risultare subito selezionate
              const _check = check
              if (_check.hidden) {
                _check.accepted = true
              }
              return _check
            })
          )
        : state.contrattoFindomesticCheckBoxes

      const assicurazioniLinks = action.payload.data.result.assicurazioni
      const newFirmaAssicurazioni = state.firmaAssicurazioni.map(el => {
        const assKey = el.key
        if (assicurazioniLinks[assKey]) {
          el.links = assicurazioniLinks[assKey].links
        }

        return el
      })

      return {
        ...state,
        contrattoInfocertLinks,
        contrattoInfocertCheckBoxes,
        contrattoFindomesticLinks,
        contrattoFindomesticCheckBoxes,
        firmaAssicurazioni: newFirmaAssicurazioni,
      }

    case types.GET_FINDOMESTIC_SERVIZI_ASSICURATIVI:
    case types.GET_FINDOMESTIC_PRODOTTI_ASSICURATIVI_FROM_ID_PIANO_RIMBORSO_OUTPUT:
      const servizi_assicurativi = action.payload.data.result.map(s => {
        const servizio = { ...s }

        const previousService = state.servizi_assicurativi.find(
          o => o.id_prodotto_assicurativo === servizio.id_prodotto_assicurativo
        )

        if (
          typeof previousService !== 'undefined' &&
          previousService.selected_durata !== 'undefined'
        ) {
          servizio.selected_durata = previousService.selected_durata
        }

        if (servizio.id_prodotto_assicurativo !== undefined) {
          servizio.id = servizio.id_prodotto_assicurativo
        }
        if (servizio.codice_prodotto_assicurativo !== undefined) {
          servizio.codice = servizio.codice_prodotto_assicurativo
        }

        try {
          if (typeof servizio.questionario_adeguatezza === 'string') {
            servizio.questionario_adeguatezza = JSON.parse(
              servizio.questionario_adeguatezza
            )
          }
        } catch (e) {
          servizio.questionario_adeguatezza = false
        }

        try {
          if (
            servizio.questionario_medico &&
            typeof servizio.questionario_medico === 'string'
          ) {
            servizio.questionario_medico = JSON.parse(
              servizio.questionario_medico
            )
            if (
              servizio.questionario_medico &&
              servizio.questionario_medico.clauses
            ) {
              // aggiungo un suffisso per poi distinguerlo quando l'utente lo compila assieme al questionaro assicurativo
              servizio.questionario_medico.clauses =
                servizio.questionario_medico.clauses.map(c => {
                  c.id = `${c.id}_medico`
                  return c
                })
            }
          } else {
            // il questionario medico non e' presente
            servizio.questionario_medico = false
          }
        } catch (e) {
          servizio.questionario_medico = false
        }

        // BRUM-9525 decodifico json vincolo_prodotti
        try {
          if (
            servizio.vincolo_prodotti &&
            typeof servizio.vincolo_prodotti === 'string'
          ) {
            servizio.vincolo_prodotti = JSON.parse(servizio.vincolo_prodotti)
          }
        } catch (e) {}

        return servizio
      })
      return { ...state, servizi_assicurativi }
    case types.FINDOMESTIC_SELECT_SERVIZIO_ASSICURATIVO:
      const sa = state.servizi_assicurativi_selezionati
      sa.push(getServizioAssicurativoUid(action.payload))
      return { ...state, servizi_assicurativi_selezionati: sa }
    case types.FINDOMESTIC_UNSELECT_SERVIZIO_ASSICURATIVO:
      const _sa = state.servizi_assicurativi_selezionati
      remove(_sa, el => el === getServizioAssicurativoUid(action.payload))
      const newState = { servizi_assicurativi_selezionati: _sa }
      if (_sa.length === 0) {
        // se non ho servizi assicurativi si usa il
        // piano rimborso originale
        newState.finanziamentoAssicurato = {}
      }
      return { ...state, ...newState }
    case types.FINDOMESTIC_UNSELECT_ALL_SERVIZI_ASSICURATIVI:
      const _newState = {
        servizi_assicurativi_selezionati: [],
        finanziamentoAssicurato: {},
      }
      return { ...state, ..._newState }
    case types.POST_FINDOMESTIC_CALCOLATRICE_ASSICURAZIONI:
      return {
        ...state,
        finanziamentoAssicurato: findomestic2compass(
          action.payload.data.result
        )[0],
      }
    case types.FINDOMESTIC_CLEAR_FINANZIAMENTO_ASSICURATO:
      return {
        ...state,
        finanziamentoAssicurato: {},
        servizi_assicurativi_selezionati: [],
      }
    case types.FINDOMESTIC_SET_DURATA_SERVIZIO_ASSICURATIVO:
      const { durata } = action.payload
      const _servizio = action.payload.servizio
      const serviziAssicurativi = state.servizi_assicurativi.map(servizio => {
        if (
          _servizio.codice === servizio.codice &&
          _servizio.modalita === servizio.modalita &&
          _servizio.tipologia_prodotto === servizio.tipologia_prodotto
        ) {
          servizio.selected_durata = durata
        }

        return servizio
      })

      return { ...state, servizi_assicurativi: serviziAssicurativi }
    default:
      return state
  }
}

export const uuid = function uuid(state = null, action) {
  switch (action.type) {
    case types.STORE_RESTORE_CALLBACK:
      const restoreUuid = action.payload.data.result.frontend.uuid
      // per supportare restore che non hanno uuid
      return restoreUuid === undefined ? null : restoreUuid
    case types.SET_UUID:
      return action.payload
    default:
      return state
  }
}

export function garanzia(state = {}, action) {
  switch (action.type) {
    case actions.NEW_PRODUCT_WARRANTY:
      return action.payload.data.result
    default:
      return state
  }
}

export function rerouteTo(state = null, action) {
  switch (action.type) {
    case 'SET_REROUTE':
      return action.payload
    default:
      return state
  }
}

const combinedReducers = combineReducers({
  product,
  customer,
  documentation,
  privacy,
  acceptance,
  pricing,
  financements,
  findomestic,
  payment,
  ordine,
  secci,
  compass,
  comuni,
  error,
  compass_tabelledominio,
  compassFileUpload,
  bonificoFileUpload,
  distintaFileUpload,
  transazioni,
  logistica,
  routing: routerReducer,
  ui,
  uuid,
  nlt,
  findomesticFileUpload,
  garanzia,
  rerouteTo,
  stepsVisited,
})

const rootReducer = (state = {}, action) => combinedReducers(state, action)

export default rootReducer
